import { render } from "./PostCategories.vue?vue&type=template&id=a334a8c2"
import script from "./PostCategories.vue?vue&type=script&lang=js"
export * from "./PostCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/farmfeed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__